import React, { useState, useEffect } from 'react';
import { Activity, Plus, TrendingUp } from 'lucide-react';
import Swal from 'sweetalert2';

const ActiveAlgos: React.FC = () => {
  const [algos, setAlgos] = useState<any[]>([]);
  const [formData, setFormData] = useState({ stock_name: '', symbol: '', min_investment: '' });

  const fetchAlgos = async () => {
    const res = await fetch('https://motilalalgo.com/api/admin/algos');
    const data = await res.json();
    if (data.success) setAlgos(data.algos);
  };

  useEffect(() => { fetchAlgos(); }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await fetch('https://motilalalgo.com/api/admin/add-algo', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });
    const data = await res.json();
    if (data.success) {
      Swal.fire('Success', 'Stock Added to Market', 'success');
      setFormData({ stock_name: '', symbol: '', min_investment: '' });
      fetchAlgos();
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 mb-6 flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-black text-slate-800">Active Algos & Stocks</h1>
          <p className="text-sm text-slate-500">List stocks that users can invest in.</p>
        </div>
        <Activity size={36} className="text-[#3b36a4]" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1 bg-white p-6 rounded-2xl shadow-sm border border-slate-100 h-fit">
          <h3 className="font-bold text-slate-800 mb-4">Add New Stock</h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input type="text" required placeholder="Company Name (e.g. Tata Motors)" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl" value={formData.stock_name} onChange={e => setFormData({...formData, stock_name: e.target.value})} />
            <input type="text" required placeholder="Symbol (e.g. TATAMOTORS)" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl uppercase" value={formData.symbol} onChange={e => setFormData({...formData, symbol: e.target.value.toUpperCase()})} />
            <input type="number" required placeholder="Min Investment (₹)" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl" value={formData.min_investment} onChange={e => setFormData({...formData, min_investment: e.target.value})} />
            <button className="w-full bg-[#3b36a4] text-white font-bold py-3 rounded-xl flex justify-center gap-2 items-center hover:bg-[#2d2780]"><Plus size={18}/> Add to Market</button>
          </form>
        </div>

        <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
          <table className="w-full text-left">
            <thead className="bg-slate-50 border-b border-slate-100 text-xs uppercase text-slate-500 font-bold">
              <tr><th className="p-4">Stock Details</th><th className="p-4">Min Inv.</th><th className="p-4">Status</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {algos.map((a, i) => (
                <tr key={i} className="hover:bg-slate-50">
                  <td className="p-4"><p className="font-bold text-slate-800">{a.symbol}</p><p className="text-xs text-slate-500">{a.stock_name}</p></td>
                  <td className="p-4 font-bold text-slate-700">₹{a.min_investment}</td>
                  <td className="p-4"><span className="bg-emerald-100 text-emerald-700 text-[10px] font-bold px-2 py-1 rounded">LIVE</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default ActiveAlgos;